import {
  type DocumentMeta,
  type DocumentStatus,
} from "@prismicio/editor-fields"

import type { BrokenLink } from "./bulkActionsService"

export function getStatusFilter(
  status: DocumentStatus | undefined,
  releaseId: string | undefined,
): string {
  if (!status) return ""

  if (status === "release" && releaseId) return `release:${releaseId}`

  return status
}

export function transformDocumentToBulkTaskItem(
  document: BrokenLink | DocumentMeta,
  releaseId: string | undefined,
) {
  if ("documentId" in document) {
    return {
      documentId: document.documentId,
      versionId: document.versionId,
      status: getStatusFilter(document.versionStatus, releaseId),
    }
  }

  return {
    documentId: document.id,
    versionId: document.versions[0]?.version_id ?? "",
    status: getStatusFilter(document.versions[0]?.status, releaseId),
  }
}
